import { useGlobalConfig } from '@otovo/shared/hooks/configContext';
import { useIntl } from 'react-intl';
import BreezeAddressSearch from '../../../components/BreezeAddressSearch/BreezeAddressSearch';
import BreezeHead from '../../../components/BreezeHead';
import { getServerSideProps } from '../../../config/getProps';
import { messages as m } from './search';

/**
 * This page will serve the address search using SSR\
 *
 * - /search will serve a statically generated search-bar for optimal performance
 * - /search-ssr will serve a server-side-rendered search bar to avoid including the GTM tracking script in _app.js
 *
 * This is done to conditionally disable GTM loading in _app.js.
 */
const SearchSSR = (): React.ReactNode => {
  const intl = useIntl();
  const { BU_CONFIG } = useGlobalConfig();
  return (
    <>
      <BreezeHead
        title={intl.formatMessage(m.pageTitle, {
          companyName: BU_CONFIG.company_name,
        })}
      />

      <BreezeAddressSearch />
    </>
  );
};

export { getServerSideProps };
export default SearchSSR;
